export default __webpack_public_path__ + "static/media/education_2.7324c52a.png";